import React, { useEffect, useRef, useState } from 'react';
import { t } from '../../i18n/t';

interface CredentialsStepProps {
  onSubmit: (email: string, password: string) => void;
  isSubmitting: boolean;
  error: string | null;
}

export function CredentialsStep({ onSubmit, isSubmitting, error }: CredentialsStepProps) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const emailRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    emailRef.current?.focus();
  }, []);

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    onSubmit(email, password);
  }

  return (
    <form onSubmit={handleSubmit} className="login-form">
      {error && (
        <div className="login-form__error" role="alert">
          {error}
        </div>
      )}
      <div>
        <label htmlFor="login-email">{t('auth.email')}</label>
        <input
          id="login-email"
          ref={emailRef}
          type="email"
          required
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={isSubmitting}
        />
      </div>
      <div>
        <label htmlFor="login-password">{t('auth.password')}</label>
        <input
          id="login-password"
          type="password"
          required
          minLength={1}
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={isSubmitting}
        />
      </div>
      <button
        type="submit"
        className="login-form__submit"
        disabled={isSubmitting || !email || !password}
      >
        {isSubmitting ? t('auth.submitting') : t('auth.submit')}
      </button>
    </form>
  );
}
